const catalogueFormActions = {
  ADD_CATALOGUE_LINK: 'ADD_CATALOGUE_LINK',
  ADD_CATALOGUE_OBJECT: 'ADD_CATALOGUE_OBJECT',
  APPLY_CATALOGUE_OBJECTS: 'APPLY_CATALOGUE_OBJECTS',
  DELETE_ACTIVE_CATALOGUE_OBJECT: 'DELETE_ACTIVE_CATALOGUE_OBJECT',
  DELETE_CATALOGUE_OBJECT: 'DELETE_CATALOGUE_OBJECT',
  EDIT_CATALOGUE_OBJECTS: 'EDIT_CATALOGUE_OBJECTS',
  HIDE_CATALOGUE_OBJECTS: 'HIDE_CATALOGUE_OBJECTS',
  INSERT_CATALOGUE_LINK: 'INSERT_CATALOGUE_LINK',
  INSERT_CATALOGUE_OBJECT: 'INSERT_CATALOGUE_OBJECT',
  SHOW_CATALOGUE_LINKS: 'SHOW_CATALOGUE_LINKS',
  SHOW_CATALOGUE_OBJECTS: 'SHOW_CATALOGUE_OBJECTS',
  UPDATE_ACTIVE_CATALOGUE_OBJECT: 'UPDATE_ACTIVE_CATALOGUE_OBJECT',
  UPDATE_CATALOGUE_OBJECT_PROPERTIES: 'UPDATE_CATALOGUE_OBJECT_PROPERTIES',
  UPDATE_CATALOGUE_OBJECTS_PROPERTIES: 'UPDATE_CATALOGUE_OBJECTS_PROPERTIES',
  UPDATE_DATASET_CATALOGUE_OBJECT_PROPERTIES: 'UPDATE_DATASET_CATALOGUE_OBJECT_PROPERTIES',
};

export default catalogueFormActions;
